import { render, staticRenderFns } from "./ItserveNotification.vue?vue&type=template&id=a15b10d8&scoped=true&"
import script from "./ItserveNotification.vue?vue&type=script&lang=js&"
export * from "./ItserveNotification.vue?vue&type=script&lang=js&"
import style0 from "./ItserveNotification.vue?vue&type=style&index=0&id=a15b10d8&prod&scoped=true&lang=css&"
import style1 from "./ItserveNotification.vue?vue&type=style&index=1&id=a15b10d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15b10d8",
  null
  
)

export default component.exports